import { FC } from "react";

import { MatrixDiagram } from "../../../Charts/MatrixDiagram/MatrixDiagram";

import { AvgMaterialCompositionSmallHomeAppliancesProps } from "./AvgMaterialCompositionSmallHomeAppliances.type";
import { AvgMaterialCompositionSmallHomeAppliancesTooltip } from "./AvgMaterialCompositionSmallHomeAppliancesTooltip/AvgMaterialCompositionSmallHomeAppliancesTooltip";

const CATEGORY_LABELS: Record<string, string> = {
	microwaves: "Microwaves",
	foodProcessing: "Food Processing",
	hotWater: "Hot Water",
	vacuumCleaners: "Vacuum Cleaners",
	personalCare: "Personal Care",
	otherSmallAppliances: "Other Small Appliances",
};

const MATERIAL_LABELS: Record<string, string> = {
	acryloniteButadieneStyrene: "Acrylonitrile Butadiene Styrene",
	aluminium: "Aluminium",
	concrete: "Concrete",
	copper: "Copper",
	electronics: "Electronics",
	ferro: "Ferro",
	glass: "Glass",
	highImpactPolystyrene: "High Impact Polystyrene",
	pcAbsAlloy: "PC-ABS Alloy",
	polyamide: "Polyamide",
	polybutyleneTerephthalate: "Polybutylene Terephthalate",
	polycarbonates: "Polycarbonates",
	polyethylene: "Polyethylene",
	polyoxymethylene: "Polyoxymethylene",
	polypropylene: "Polypropylene",
	polystyrene: "Polystyrene",
	polyurethane: "Polyurethane",
	polyvinylChloride: "Polyvinyl Chloride",
	stainlessSteel: "Stainless Steel",
	otherPlastics: "Other Plastics",
	other: "Other",
};

const AvgMaterialCompositionSmallHomeAppliances: FC<AvgMaterialCompositionSmallHomeAppliancesProps> = ({ data }) => {
	const xAxisLabels = (() => {
		if (!Array.isArray(Object.values(data)[0])) {
			return [];
		}
		const categories = Object.values(data)[0]?.map((entry) => entry.category);
		return categories.map((entry) => CATEGORY_LABELS[entry] ?? entry);
	})();

	return (
		<div>
			<MatrixDiagram
				data={data}
				titles={xAxisLabels}
				Tooltip={AvgMaterialCompositionSmallHomeAppliancesTooltip}
				yAxisLabels={MATERIAL_LABELS}
				range={[0, 4000]}
			/>
		</div>
	);
};

export { AvgMaterialCompositionSmallHomeAppliances };
